import * as React from 'react';
import createTranslatorProps from './createTranslatorProps';
import createTranslator from '../tools/createTranslator';
var TranslatorPropsContext = /*#__PURE__*/React.createContext(createTranslatorProps(createTranslator({})));
export default TranslatorPropsContext;